import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "alpen_cookie_consent";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const choice = localStorage.getItem(KEY);
        if (!choice) setVisible(true);
    }, []);

    const persist = (val) => {
        localStorage.setItem(KEY, val);
        localStorage.setItem(`${KEY}_at`, new Date().toISOString());
        setVisible(false);
        window.dispatchEvent(new CustomEvent("alpen:cookie-consent", { detail: val }));
    };

    if (!visible) return null;

    return (
        <div
            className="fixed inset-x-0 bottom-0 z-50 p-3 sm:p-4"
            role="dialog"
            aria-live="polite"
            aria-label="Cookie-Hinweis"
            data-testid="cookie-banner"
        >
            <div className="max-w-3xl mx-auto rounded-2xl border border-[rgba(185,194,207,0.18)] bg-[rgba(14,20,31,0.92)] backdrop-blur-md card-elevated">
                <div className="p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
                    <div className="flex items-start gap-3 flex-1">
                        <div className="shrink-0 h-10 w-10 rounded-xl bg-[rgba(46,168,255,0.12)] border border-[rgba(46,168,255,0.25)] flex items-center justify-center">
                            <Cookie className="h-5 w-5 text-[#7BD3FF]" />
                        </div>
                        <div>
                            <p className="text-sm text-[#F4F7FB]">
                                Wir verwenden technisch notwendige Cookies. Weitere
                                Cookies nur mit Ihrer Zustimmung.{" "}
                                <Link
                                    to="/cookie-policy"
                                    className="underline underline-offset-2 text-[#7BD3FF] hover:text-white"
                                    data-testid="cookie-open-policy-link"
                                >
                                    Mehr erfahren
                                </Link>
                                .
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 sm:flex-row flex-row w-full sm:w-auto">
                        <button
                            onClick={() => persist("declined")}
                            className="flex-1 sm:flex-none px-4 h-10 rounded-xl border border-white/[0.14] text-sm text-[#C9D3E1] hover:text-white hover:border-[rgba(123,211,255,0.45)] transition-colors"
                            data-testid="cookie-decline-button"
                        >
                            Ablehnen
                        </button>
                        <button
                            onClick={() => persist("accepted")}
                            className="flex-1 sm:flex-none px-4 h-10 rounded-xl bg-[#2EA8FF] text-[#07090C] text-sm font-medium hover:bg-[#7BD3FF] transition-colors btn-glow"
                            data-testid="cookie-accept-button"
                        >
                            Akzeptieren
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
